import React from 'react';
import { FaCode, FaMaintenance, FaSearch, FaLightbulb } from 'react-icons/fa';
import { Link } from 'react-scroll';

const About = () => {
  return (
    <section id="about" className="section-padding bg-gray-50">
      <div className="container-max">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="section-title">
            About <span className="gradient-text">Pandit Dhananjay Pandey</span>
          </h2>
          <p className="section-subtitle">
            A renowned astrologer and spiritual guide serving communities across India and internationally with 
            traditional Vedic wisdom and Tantra knowledge since 2007.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8 mt-0 lg:mt-[-80px]">
            <div>
              <h3 className="text-3xl font-bold mb-6 font-heading">
                Vedic Scholar & Tantra Expert from Uttar Pradesh
              </h3>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                <strong>Background & Early Life:</strong> Pandit Dhananjay Pandey was born in a Brahmin family in Panditpura village near Bhatni, 
                which is in Deoria district of Uttar Pradesh. Since childhood, he had an interest in Sanskrit grammar and knowledge of Vedas. 
                His primary education started from Sangved Sanskrit Mahavidyalaya Bhatni and Sastri and Acharya Sampurnanand Sanskrit Mahavidyalaya Varanasi.
              </p>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                <strong>Spiritual Training:</strong> Thereafter, he acquired knowledge of Tantra Vigyan and Mantra Samhita under the guidance of great Gurus 
                and learnt to get rid of human calamities and invisible obstacles in life. Through this ancient wisdom, he has been serving people 
                with Indian astrology and Tantra knowledge since 2007.
              </p>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                <strong>Service Areas:</strong> From 2007 to 2025, people have been benefited from his expertise across multiple states including 
                Punjab, Delhi, Uttar Pradesh, Bihar, Karnataka, Rajasthan, Maharashtra, Haryana and also in foreign countries like Kazakhstan, 
                Fiji, Australia and Indonesia.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                <strong>Established Centers:</strong> In 2010, Nakshatra Astrology Center was established in Bhatni and in 2015, its office was 
                opened in home district Deoria where doubts of 75 people are resolved in a pre-determined manner three days a week. Along with that, 
                in Bangalore and Punjab, continuous uninterrupted service is being provided where daily land testing, horoscope analysis, investigation, 
                and invisible obstacle problems of 60 people are resolved. Today, by taking time in advance for any information, you can get solution 
                to your career related problems.
              </p>
            </div>

            

            {/* Services Overview */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                  <FaSearch className="text-primary text-xl" />
                </div>
                <h4 className="text-xl font-semibold mb-2">Vedic Knowledge</h4>
                <p className="text-gray-600 text-sm">
                  Deep expertise in Sanskrit grammar, Vedic scriptures, and traditional astrological analysis based on ancient wisdom.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="w-12 h-12 bg-secondary/10 rounded-lg flex items-center justify-center mb-4">
                  <FaLightbulb className="text-secondary text-xl" />
                </div>
                <h4 className="text-xl font-semibold mb-2">Tantra Vigyan</h4>
                <p className="text-gray-600 text-sm">
                  Specialized knowledge in Tantra science and Mantra Samhita to help resolve invisible obstacles and life challenges.
                </p>
              </div>
            </div>

            {/* CTA Button */}
            <div className="pt-4">
              <button className="btn-primary">
                <Link
                to="contact"
                smooth={true}
                duration={500}
                offset={-70}
                className="btn-primary cursor-pointer text-center"
              >
                Book a Reading
              </Link>
                
              </button>
            </div>
          </div>

          {/* Right Content - Stats & Image */}
          <div className="space-y-8">
            {/* Profile Image */}
            <div className="relative">
              <div className="w-full h-96 rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="/images/user/IMG-20250831-WA0011 - s.jpg" 
                  alt="Dhananjay Pandey Bhatni - Professional Astrologer"
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-700"
                  onError={(e) => {
                    e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400' viewBox='0 0 400 400'%3E%3Cdefs%3E%3ClinearGradient id='gradient' x1='0%25' y1='0%25' x2='100%25' y2='100%25'%3E%3Cstop offset='0%25' style='stop-color:%232563eb;stop-opacity:1' /%3E%3Cstop offset='100%25' style='stop-color:%23f59e0b;stop-opacity:1' /%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='400' height='400' fill='%23f8fafc'/%3E%3Ctext x='200' y='180' font-family='Poppins, sans-serif' font-size='48' font-weight='bold' text-anchor='middle' fill='url(%23gradient)'%3EDK%3C/text%3E%3Ctext x='200' y='220' font-family='Poppins, sans-serif' font-size='24' text-anchor='middle' fill='%236b7280'%3EPANDEY BHATNI%3C/text%3E%3Ctext x='200' y='250' font-family='Poppins, sans-serif' font-size='16' text-anchor='middle' fill='%236b7280'%3EAstrologer%3C/text%3E%3C/svg%3E";
                  }}
                />
              </div>
              
              {/* Decorative elements */}
              <div className="absolute -top-4 -right-4 w-8 h-8 bg-primary rounded-full animate-float opacity-80"></div>
              <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-secondary rounded-full animate-float opacity-60" style={{animationDelay: '2s'}}></div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4">
              <div className="text-center bg-white p-6 rounded-xl shadow-lg">
                <div className="text-3xl font-bold text-primary mb-2">22+</div>
                <div className="text-gray-600 text-sm">Years Experience</div>
              </div>
              <div className="text-center bg-white p-6 rounded-xl shadow-lg">
                <div className="text-3xl font-bold text-primary mb-2">75</div>
                <div className="text-gray-600 text-sm">Daily Consultations</div>
              </div>
              <div className="text-center bg-white p-6 rounded-xl shadow-lg">
                <div className="text-3xl font-bold text-primary mb-2">9+</div>
                <div className="text-gray-600 text-sm">Countries Served</div>
              </div>
            </div>

            {/* Client Gallery */}
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <h4 className="font-semibold text-gray-800 mb-4">Trusted by Amazing People</h4>
              <div className="grid grid-cols-6 gap-2">
                {[
                  'IMG-20250831-WA0008.jpg', 'IMG-20250831-WA0017.jpg', 'IMG-20250831-WA0022.jpg',
                  'IMG-20250831-WA0028.jpg', 'IMG-20250831-WA0034.jpg', 'IMG-20250831-WA0038.jpg'
                ].map((img, index) => (
                  <div key={img} className="aspect-square rounded-lg overflow-hidden border-2 border-gray-100 hover:border-primary/50 transition-all duration-300 hover:scale-110">
                    <img 
                      src={`/images/user/${img}`} 
                      alt={`Client ${index + 1}`}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextElementSibling.style.display = 'flex';
                      }}
                    />
                    <div className="w-full h-full bg-gradient-to-br from-primary/20 to-secondary/20 hidden items-center justify-center">
                      <div className="w-3 h-3 bg-primary rounded-full"></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Hindi Biography Section */}
            <div className="bg-gradient-to-r from-primary/5 to-secondary/5 p-6 rounded-xl border-l-4 border-primary">
              <h4 className="text-2xl font-bold mb-4 text-primary font-heading">हिंदी में परिचय</h4>
              <div className="text-gray-700 leading-relaxed space-y-4" style={{fontFamily: 'inherit', fontSize: '16px', lineHeight: '1.8'}}>
                <p>
                  पंडित धनंजय पांडे का जन्म भटनी के नजदिक गांव पंडितपुरा में एक ब्राह्मण के घर में हुआ था जो देवरिया जनपद उत्तर प्रदेश के अंदर हैं। 
                  बाल्यकाल से ही उनमें संस्कृत व्याकरण एवं वेदशास्त्र के ज्ञान की अभिरुचि थी। प्राथमिकी शिक्षा सांगवेद संस्कृत महा विद्यालय भटनी से सुरु हुई, 
                  व शास्त्री व आचार्य सम्पूर्णनांद संस्कृत महा विद्यालय वाराणसी से सम्पन्न हुई।
                </p>
                <p>
                  तत्पश्चात् उन्होंने श्रेष्ट गुरुजनो के सानिध्य में तंत्र विज्ञान और मंत्र संहिता का ज्ञान प्राप्त किया जीवन मानवीक प्रकोप, अदृश्य बाधा से ग्रसित से निजात पाने की विद्या प्राप्त किया। 
                  जिसके माध्यम से विगत 2007 से आज 2025 तक पंजाब, दिल्ली, उत्तरप्रदेश, बिहार कर्नाटक, राजस्थान, महाराष्ट्र, हरियाणा सहित विदेश मे क़ज़ाकिस्तान, फिजी ऑस्ट्रेलिया, 
                  व इंडोनेसिया, मे भी भारतीय फलित ज्योतिष व तंत्र ज्ञान के से लोगो क़ो लाभान्वित किया गया है।
                </p>
                <p>
                  2010 मे नक्षत्र ज्योतिष केंद्र भटनी मे स्थापना की गई उसके 2015 मे गृह जनपद देवरिया मे कार्यालय खोला गया जहा निरंतर हप्ते मे तीन दिन 75 लोगो क़ो पूर्व समय बद्ध तरीके से शंका समाधान किया जाता है। 
                  उसी के साथ, बेंगलोरे, पंजाब मे निरंतर निर्विवाद सेवा दिया जा रहा नित्य 60 लोगो का भूमि परिक्षण, कुंडली, विवेचना, अदृश्य बाधा का समाधान किया जाता है। 
                  आज किसी भी जानकारी के लिए पहले समय लेकर अपने कैरियर संबंधी समस्या का समाधान पा सकतें है।
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
